(function() { window.GUID_8c5a3efa_a2a2_4d83_9ebd_8643dc3add3a = { getGuid: function() { return "8c5a3efa-a2a2-4d83-9ebd-8643dc3add3a"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Purchase extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
            }
            OnDispose() {
                this.$Control.off('click.' + this.UniqueNamespace, '.purchase-consumable');
                this.$Control.off('click.' + this.UniqueNamespace, '.purchase-subscription-monthly');
                this.$Control.off('click.' + this.UniqueNamespace, '.purchase-subscription-yearly');
                this.$Control.remove();
            }
            OnBindEvents() {
                let me = this;
                me.$Control.offon('click.' + this.UniqueNamespace, '.purchase-consumable', function (e) {
                    var purchase = JSON.stringify({ item: "compusport.notification", event: CS.CommonData.Current.Navigation.EventId, });
                    CS.NativeApp.NA_PurchaseConsumable(purchase);
                });
                me.$Control.offon('click.' + this.UniqueNamespace, '.purchase-subscription-monthly', function (e) {
                    CS.NativeApp.NA_PurchaseSubscription("compusport.subscription.month.10");
                });
                me.$Control.offon('click.' + this.UniqueNamespace, '.purchase-subscription-yearly', function (e) {
                    CS.NativeApp.NA_PurchaseSubscription("compusport.subscription.yearly.10");
                });
            }
        }
        Controls.Purchase = Purchase;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=purchase.js.map
